export default {"src":"/_next/static/media/popular-cars-menu-1.2356c361.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};